export type Surface = 'home' | 'panel';

/**
 * Un solo sitio, un solo origen: "/panel" (o "/panel/algo") es el panel,
 * "/admin" es la administración del equipo y `/systems` la infraestructura —
 * fuera de la superficie pública —, cualquier otra ruta es la superficie
 * pública. Nada de subdominios separados ni de "?surface=" en la URL — eso
 * complicaba más de lo que resolvía (ida y vuelta entre dominios) y no es
 * una ruta que alguien pueda reconocer ni compartir.
 */
export function resolveSurface(pathname: string): Surface {
  const isPanel = pathname === '/panel' || pathname.startsWith('/panel/');
  const isAdmin = pathname === '/admin' || pathname.startsWith('/admin/');
  const isSystems = pathname === '/systems' || pathname.startsWith('/systems/');
  return isPanel || isAdmin || isSystems ? 'panel' : 'home';
}

/** Enlace a otra superficie, opcionalmente a una ruta concreta dentro de ella
 * (por ejemplo, "/activities" en la superficie "home"). */
export function surfaceHref(surface: Surface, path = '/'): string {
  if (surface === 'panel') return `/panel${path === '/' ? '' : path}`;
  return path;
}
